import React from "react";
import CheckmarkGreenIcon from "../../../../../assets/svg/icons/common/checkmark-green";
import {
  file_type_options,
  package_options,
  cable_length_options,
  connectivity_options,
} from "../../../../../../constants";

export const valueRenderer = (data) => {
  const { item, models, options } = data;

  if (item.type === "string") {
    return item?.value || "-";
  }

  if (item.type === "boolean") {
    return item?.value == 1 || item?.value == "yes" ? (
      <span style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
        <CheckmarkGreenIcon /> Yes
      </span>
    ) : (
      ""
    );
  }

  if (item.type === "amount") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(item?.value);
  }

  if (item.type === "equipmentIdString") {
    return item?.value
      .split(",")
      .map((id) => models.find((m) => m.id == id)?.equipment_name)
      .join(", ");
  }

  if (item.type === "equipmentIdArrayString") {
    return item?.value
      ?.map((id) => models.find((m) => m.id == id)?.equipment_name)
      .join(", ");
  }

  if (item.type === "optionString") {
    return item?.value
      .split(",")
      .map((o) => options[o])
      .join(", ");
  }

  return item?.value;
};

export const getOptionsBasedOnField = (field) => {
  if (field === "file_types") {
    return file_type_options;
  }

  if (field === "package") {
    return package_options;
  }

  if (field === "cable_length") {
    return cable_length_options;
  }

  if (field === "connectivity") {
    return connectivity_options;
  }
};
